import React from 'react';
import cx from 'classnames';
import Icon from './Icon';

class Search extends React.PureComponent {
  constructor(props) {
    super(props);

    this.submitSearch = this.submitSearch.bind(this);
  }

  componentWillReceiveProps({ searchOpen }) {
    if (searchOpen) {
      this.elem.value = '';
    }
  }

  submitSearch(e) {
    let searchValue = '';
    const searchInput = document.querySelector('input.search__input');
    if (e.key === 'Enter') {
      searchValue = searchInput.value;
      this.props.history.push('/search/?q=' + searchValue);
      this.props.handleToggleSearch();
    }
  }

  render() {
    const { history, searchOpen, handleToggleSearch } = this.props;

    return (
      <div className="search__wrapper absolute top-0 left-0 w-100">
        <div
          className={cx('search__content bg-dark h-100 flex items-center', {
            isOpen: this.props.searchOpen
          })}
        >
          <Icon path="icon-18-search" className="h-100 flex items-center" />
          <input
            ref={e => {
              this.elem = e;
            }}
            className="search__input w-100 bn bg-dark p mh1"
            type="text"
            placeholder="Search Downtown..."
            onKeyPress={this.submitSearch}
          />
          <div onClick={handleToggleSearch} className="pointer">
            <Icon path="icon-18-dismiss" className="h-100 flex items-center" />
          </div>
        </div>
      </div>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/components/Search.js